/**
 * Admin Layout Component
 * Provides consistent navigation sidebar for all admin pages
 */

import { NavLink, Outlet } from 'react-router-dom';

const adminNavItems = [
  { path: '/admin', label: 'Dashboard', icon: 'dashboard', end: true },
  { path: '/admin/users', label: 'Users', icon: 'group' },
  { path: '/admin/skus', label: 'SKUs', icon: 'sell' },
  { path: '/admin/feature-requests', label: 'Feature Requests', icon: 'lightbulb' },
  { path: '/admin/analytics', label: 'Analytics', icon: 'analytics' },
  { path: '/admin/audit-logs', label: 'Audit Logs', icon: 'history' },
];

export function AdminLayout() {
  return (
    <div className="flex h-screen w-full bg-white dark:bg-gray-900">
      {/* Admin Sidebar */}
      <nav className="w-64 shrink-0 border-r border-gray-200 bg-white p-4 dark:border-gray-800 dark:bg-gray-900 overflow-y-auto">
        <h2 className="mb-6 text-lg font-semibold text-gray-900 dark:text-white">Administration</h2>
        <ul className="space-y-1">
          {adminNavItems.map((item) => (
            <li key={item.path}>
              <NavLink
                to={item.path}
                end={item.end}
                className={({ isActive }) =>
                  `flex items-center gap-3 rounded-lg px-3 py-2 text-sm font-medium transition-colors ${
                    isActive
                      ? 'bg-blue-100 text-blue-700 dark:bg-blue-900/30 dark:text-blue-300'
                      : 'text-gray-600 hover:bg-gray-100 dark:text-gray-400 dark:hover:bg-gray-800'
                  }`
                }
              >
                <span className="material-symbols-outlined text-xl">{item.icon}</span>
                {item.label}
              </NavLink>
            </li>
          ))}
        </ul>
      </nav>

      {/* Main Content */}
      <main className="flex-1 overflow-y-auto p-6">
        <Outlet />
      </main>
    </div>
  );
}

export default AdminLayout;
